{
  "version": 1,
  "asset_id": "7a951a20-87bc-4583-8e84-30b896f4c7b9",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/7a951a20-87bc-4583-8e84-30b896f4c7b9/rv_parts.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/7a951a20-87bc-4583-8e84-30b896f4c7b9/rv_parts.webp",
  "original_filename": "rv_parts.webp",
  "size": 33620,
  "content_type": "image/webp",
  "created_at": "2026-07-14T02:53:35Z"
}
